import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_popup = _resolveComponent("error-popup")!
  const _component_information_popup = _resolveComponent("information-popup")!
  const _component_loader_popup = _resolveComponent("loader-popup")!
  const _component_menu_bar = _resolveComponent("menu-bar")!
  const _component_login = _resolveComponent("login")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_intl = _resolveComponent("intl")!
  const _component_localization = _resolveComponent("localization")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_localization, { language: 'de-DE' }, {
      default: _withCtx(() => [
        _createVNode(_component_intl, { locale: 'de' }, {
          default: _withCtx(() => [
            ($setup.errorDialogParameter.isErrorDialog)
              ? (_openBlock(), _createBlock(_component_error_popup, _mergeProps({
                  key: 0,
                  onClosed: $setup.errorClosed
                }, $setup.errorDialogParameter), null, 16, ["onClosed"]))
              : _createCommentVNode("", true),
            ($setup.infoDialogParameter.isInfoDialog)
              ? (_openBlock(), _createBlock(_component_information_popup, _mergeProps({
                  key: 1,
                  onClosed: $setup.infoClosed
                }, $setup.infoDialogParameter), null, 16, ["onClosed"]))
              : _createCommentVNode("", true),
            ($setup.loaderParameter.isInProgress)
              ? (_openBlock(), _createBlock(_component_loader_popup, _normalizeProps(_mergeProps({ key: 2 }, $setup.loaderParameter)), null, 16))
              : _createCommentVNode("", true),
            ($setup.loginParameter.isAuthenticated)
              ? (_openBlock(), _createBlock(_component_menu_bar, { key: 3 }))
              : _createCommentVNode("", true),
            (!$setup.loginParameter.isAuthenticated && !$setup.errorDialogParameter.isErrorDialog && !$setup.loaderParameter.isInProgress)
              ? (_openBlock(), _createBlock(_component_login, _normalizeProps(_mergeProps({ key: 4 }, $setup.loginParameter)), null, 16))
              : _createCommentVNode("", true),
            ($setup.loginParameter.isAuthenticated)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 5 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}